


















































































































































































import { Vue, Component, Prop } from 'vue-property-decorator';

import Typography from '@/components/atoms/Typography/Typography.vue';
import Checkbox from '@/components/Checkbox/Checkbox.vue';
import PercentageCircleIcon from '@/components/icons/PercentageCircle.vue';
import CoinsIcon from '@/components/icons/Coins.vue';
import CalendarIcon from '@/components/icons/Calendar.vue';
import { ModalOptionsV2 } from '@/components/Modal/ModalOptions';
import { EProgramStatusStatus } from '@/models/program-status';

import flagKeys from '@/constants/flagKeys';

import { TCampaignStatus } from '@/models/marketingCenter/sellCoins';
import { Campaign } from '@/models/marketingCenter/sellCoins';

import { treatError } from '@/utils';
import DateUtils from '@/utils/DateUtils';
import eventBus from '@/utils/eventBus';

import SellCoinsService from '@/api/SellCoinsService';
import InfoIcon from '@/components/icons/Info.vue';

import { DashboardScreen } from '@/api/enums/dashboard-screen.enum';
import { isRemoteLoading } from '@/utils/remote-loading';
import BusinessService from '@/api/BusinessService';

@Component({
  components: {
    Typography,
    Checkbox,
    PercentageCircleIcon,
    CoinsIcon,
    CalendarIcon,
    InfoIcon
  }
})
export default class SellCoinsCampaignListItem extends Vue {
  @Prop() readonly campaign: any;
  @Prop() readonly isCampaignDetail?: boolean;
  @Prop() readonly automaticCampaign?: any;
  @Prop() canManageSellCoins!: boolean;

  sellCoinsService = new SellCoinsService();
  businessService = new BusinessService();

  loading: boolean = false;
  error: string[] = [];

  isCampaignActive: boolean = this.status;
  iconName: string = 'warning.svg';
  campaigns: Campaign[] = [];
  expiration: string = '';
  totalCount: number = 0;
  nextPage: string = '';

  campaignStatusType: TCampaignStatus = '';
  campaignStatusMap = new Map<string, string>([
    ['campaignDeactivation', 'deactivated'],
    ['campaignAlreadyActive', 'activated'],
    ['campaignActivation', 'activated'],
    ['campaignAutomaticActivation', 'deactivated']
  ]);

  get flags() {
    return this.$store.getters['flags/getFlags'] || [];
  }

  get shouldHideShareLink() {
    return this.flags.includes(flagKeys.hideSellCoinCampaignLinkSharing);
  }

  get isAutomaticallyCreated() {
    if (isRemoteLoading()) return false;
    return this.campaign.automaticallyCreated;
  }

  get showToggle() {
    return !this.isAutomaticallyCreated;
  }

  get getIsCampaignActive() {
    return (
      this.isCampaignActive &&
      this.hasSellCoinsEnabled &&
      this.canManageSellCoins
    );
  }

  get hasPurchases() {
    return +this.campaign.totalRevenue + +this.campaign.pendingRevenue > 0;
  }

  get remoteLoading() {
    return isRemoteLoading();
  }

  toggleCampaignStatus() {
    this.iconName = 'warning.svg';

    if (this.isCampaignActive) {
      this.deactivateCampaign();
    } else {
      this.handleActivation();
    }
  }

  // check to see if the selected campaign is closed
  get isSelectedCampaignClosed() {
    return this.campaign.status == 'closed';
  }

  get businessInfo() {
    return this.$store.getters['business/getBusinessInfo'].business;
  }

  // check to see if there is a campaign data
  hasActiveCampaign(campaign: Campaign) {
    return Object.keys(campaign).length !== 0;
  }

  async deactivateCampaign() {
    const activeCampaign = (await this.getActiveCampaign()) as Campaign;

    /*
     * In case there is no active campaign but exists an
     * automatic created campaign it should show
     * the campaign override activation modal
     */
    if (this.automaticCampaign && !isRemoteLoading()) {
      this.campaignStatusType = 'campaignAutomaticActivation';
      activeCampaign.endDate = this.formatDate(activeCampaign.endDate);
      this.openCampaignStatusManagementModal(
        activeCampaign,
        this.automaticCampaign
      );
      return;
    }

    this.campaignStatusType = 'campaignDeactivation';
    this.openCampaignStatusManagementModal();
  }

  async handleActivation() {
    const activeCampaign = (await this.getActiveCampaign()) as Campaign;
    /*
     * In case the selected campaign to activate is closed
     * it should show the campaign closed modal
     */
    if (this.isSelectedCampaignClosed) {
      this.campaignStatusType = 'campaignClosed';
      this.openCampaignStatusManagementModal();
      return;
    }

    /*
     * In case the loyalt ratio is higher than the
     * campaign ratio it should show the warning modal
     */
    const businessInfo = this.$store.getters['business/getBusinessInfo']
      .business;
    const rewardStatus = this.$store.getters['business/getRewardStatus']
      ? this.$store.getters['business/getRewardStatus'].rewardStatus
      : null;
    if (
      businessInfo.coinRewardPercentage > this.campaign.incentiveValue &&
      (!rewardStatus ||
        (rewardStatus === EProgramStatusStatus.ACTIVE ||
          rewardStatus === EProgramStatusStatus.PARTIALLY_ACTIVE ||
          rewardStatus === EProgramStatusStatus.PENDING)) &&
      this.$store.getters['flags/getFlags'].includes(
        flagKeys.dashboardSellCoinsAndLoyaltVerify
      )
    ) {
      this.campaignStatusType = 'campaignLoyaltRatioIssue';
      this.openCampaignStatusManagementModal(activeCampaign, this.campaign);
      return;
    }

    /*
     * In case there is no active campaign it should show the
     * campaign activation modal
     */
    if (!this.hasActiveCampaign(activeCampaign)) {
      this.campaignStatusType = 'campaignActivation';
      this.openCampaignStatusManagementModal();
      return;
    }

    /*
     * In case there is active campaign it should show
     * the campaign override activation modal
     */
    this.campaignStatusType = 'campaignAlreadyActive';
    activeCampaign.endDate = this.formatDate(activeCampaign.endDate);
    this.openCampaignStatusManagementModal(activeCampaign, this.campaign);
  }

  newCampaignEndDateFormatted(newCampaignData: Campaign) {
    if (newCampaignData && newCampaignData.endDate) {
      return DateUtils.formattedDate({
        date: newCampaignData.endDate
      });
    }

    return 'No expiration date';
  }

  openCampaignStatusManagementModal(
    activeCampaignData?: any,
    newCampaignData?: any
  ) {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'SellCoinsCampaignStatusManagementModal'
      }),
      {
        iconName: this.iconName,
        campaignType: this.campaignStatusType,
        activeCampaignData,
        newCampaignData: {
          ...newCampaignData,
          endDate: this.newCampaignEndDateFormatted(newCampaignData)
        },
        onConfirm: async () => {
          if (
            this.campaignStatusType === 'campaignClosed' ||
            this.campaignStatusType === 'campaignLoyaltRatioIssue'
          ) {
            this.gotoCreateCampaign();
            return;
          }

          if (this.campaignStatusType === 'campaignNotFound') {
            this.getInTouch();
            return;
          }

          if (this.campaignStatusType === 'campaignAlreadyActive') {
            await this.sellCoinsService.deactivateActiveCampaign();
          }

          if (isRemoteLoading()) {
            if (this.campaignStatusType === 'campaignDeactivation') {
              await this.businessService.updateSellCoins(
                false,
                DashboardScreen.Dashboard
              );
              this.$store.dispatch('business/SET_BUSINESS_INFO', {
                ...this.businessInfo,
                sellCoins: false
              });
            } else {
              await this.businessService.updateSellCoins(
                true,
                DashboardScreen.Dashboard
              );
              this.$store.dispatch('business/SET_BUSINESS_INFO', {
                ...this.businessInfo,
                sellCoins: true
              });
            }
          }

          this.changeCampaignStatus(
            newCampaignData ? newCampaignData.id : null
          );
        }
      }
    );
  }

  async changeCampaignStatus(campaignId?: string) {
    this.loading = true;

    try {
      this.sellCoinsService.disableInterception();

      const response = await this.sellCoinsService.changeCampaignStatus(
        this.campaign.id
      );

      this.loading = false;

      if (response.status === 200) {
        if (this.campaignStatusType === 'campaignAlreadyActive') {
          eventBus.$emit('disableSellingCoinsCampaigns');
        }

        if (
          this.campaignStatusType === 'campaignAutomaticActivation' &&
          campaignId
        ) {
          await this.sellCoinsService.changeCampaignStatus(campaignId);
          eventBus.$emit('enableAutomaticSellingCoinCampaign');
        }

        this.handleClose();
        this.isCampaignActive = !this.isCampaignActive;
        this.$notification(
          `Campaign successfully ${this.campaignStatusMap.get(
            this.campaignStatusType
          )}`
        );
      }
    } catch (err) {
      if (err instanceof Error) {
        this.handleErrors(err);
      }
    }
  }

  handleErrors(e: any): void {
    // Return 404 (campaign not found)

    if (e.response.status === 404) {
      this.iconName = 'error.svg';
      this.campaignStatusType = 'campaignNotFound';
      this.openCampaignStatusManagementModal();
      return;
    }

    this.$notification(treatError(e));
  }

  async getActiveCampaign() {
    try {
      this.loading = true;
      this.$showLoaderWithLocker();

      const response = await this.sellCoinsService.getActiveCampaign();

      return response.data;
    } catch (e) {
      treatError(e);
    } finally {
      this.loading = false;
      this.$hideLoader();
    }
  }

  getInTouch() {
    this.$analytics({
      eventCategory: 'Sell Coins Campaign | Ask for Support',
      eventAction: 'click',
      eventLabel: 'Clicked on the "Ask for Support!" button'
    });

    location.href = 'mailto:support@twism.com';
  }

  openSupportEmail() {
    location.href = 'mailto:hello@twism.com';
  }

  gotoCreateCampaign() {
    this.$router.push('/sell-coins/campaign/create');
  }

  gotoSellCoinsCampaign() {
    this.$router.push('/sell-coins/campaign/create');
  }

  goToPurchaseHistory() {
    this.$router.push({
      name: 'purchase-history',
      query: {
        id: this.campaign.id,
        name: this.campaign.name
      }
    });
  }

  handleClose() {
    eventBus.$emit('closeModal');
  }

  onShare() {
    eventBus.$emit(
      'openSubModal',
      new ModalOptionsV2({
        icon: 'none',
        hideCancelButton: true,
        confirmEvent: '',
        componentToRender: 'campaignShareModal'
      }),
      {
        sellingCoinsCampaign: true,
        isDetail: false,
        shareLink: this.campaign.url
      }
    );

    this.$analytics({
      eventCategory: 'Selling Coins Campaign Detail | Share campaign button',
      eventAction: 'click',
      eventLabel: 'Clicked on Share campaign button'
    });
  }

  formatDate(date: any) {
    if (date && date !== null) {
      const [formatedDate] = date.split('T');
      return DateUtils.formattedDate({ date: formatedDate });
    }

    return 'No expiration date';
  }

  turnCampaignStatusToOff() {
    this.isCampaignActive = false;
  }

  turnAutomaticCampaignStatusToOn() {
    const businessInfo = this.$store.getters['business/getBusinessInfo']
      .business;
    const rewardStatus =
      this.$store.getters['business/getRewardStatus'] &&
      this.$store.getters['business/getRewardStatus'].rewardStatus;

    if (
      (businessInfo.coinRewardPercentage <= this.campaign.incentiveValue ||
        rewardStatus === 'inactive') &&
      this.automaticCampaign.id === this.campaign.id
    ) {
      this.isCampaignActive = true;
    }
  }

  get tPrefix() {
    return 'sellCoins.campaign.list';
  }

  get campaignName() {
    return this.campaign.name;
  }

  get bonus() {
    return this.campaign.incentiveValue;
  }

  get endDate() {
    return this.formatDate(this.campaign.endDate);
  }

  get status() {
    return this.campaign.status === 'active';
  }

  get business() {
    return this.$store.getters['business/getBusinessState'];
  }

  get hasSellCoinsEnabled() {
    if (isRemoteLoading()) {
      return this.canManageSellCoins;
    }
    return this.canManageSellCoins && this.business.sellCoins;
  }

  mounted() {
    eventBus.$on('disableSellingCoinsCampaigns', this.turnCampaignStatusToOff);
    if (this.isAutomaticallyCreated) {
      eventBus.$on(
        'enableAutomaticSellingCoinCampaign',
        this.turnAutomaticCampaignStatusToOn
      );
    }
  }

  destroy() {
    eventBus.$off('disableSellingCoinsCampaigns', this.turnCampaignStatusToOff);
    if (this.isAutomaticallyCreated) {
      eventBus.$off(
        'enableAutomaticSellingCoinCampaign',
        this.turnAutomaticCampaignStatusToOn
      );
    }
  }
}
